/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_TpInputs */



/**
* | output |
* | --- |
* | "Tournament points" |
*
* @param {Score_Legend_TpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_tp = /** @type {((inputs?: Score_Legend_TpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_TpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti torneo")
	return /** @type {LocalizedString} */ ("Tournament points")
});